import { Product } from 'lib/types';

export const getProductUnit2MDescription = (product: Product) => {
    switch (product.unitM2) {
        case 'm2e':
            return 'Ilość w metrach efektywnych:';
        case 'm2c':
            return 'Ilość w metrach całkowitych:';
        default:
            return 'Ilość w metrach:';
    }
};
